import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FastTrackQuoteResult } from '@sabstravtech/obtservices/base';
import { UserService } from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-gmt-fast-track-fare-rules-modal',
  templateUrl: './gmt-fast-track-fare-rules-modal.html',
  styleUrls: ['./gmt-fast-track-fare-rules-modal.scss'],
  standalone: false
})
export class GmtFastTrackModalFareRulesComponent implements OnInit {
  fastTrack: FastTrackQuoteResult = null;
  constructor(
    public modal: NgbActiveModal,
    public userService: UserService
  ) {}

  ngOnInit(): void {}
}

LightningModalTypes.GmtFastTrackModalFareRulesComponent.component =
  GmtFastTrackModalFareRulesComponent;
